export default "__VITE_ASSET__Votw1szZ__"